import { type RefObject, useLayoutEffect, useRef } from 'react';

/**
 * The element that had focus as a dialog opened (its opener), for
 * useDialogFocus's `returnFocusTo`. Read in a layout effect, so before
 * useDialogFocus moves focus into the dialog, and read again on every open,
 * because some dialogs stay mounted while closed. Focus on <body> is no
 * opener: the ref holds null and nothing is restored on close.
 *
 * Consumers: the wallet dialogs (FundWallet, WithdrawModal, WalletSetup),
 * EditProfileModal, SubscriptionModal, SubscriptionManageModal,
 * UpgradePromptModal, usePromptDialog (and through it every prompt dialog),
 * BookingSheet and RequestEmpathySheet, the Echo Arena CharacterDetailModal
 * and RecallPanel, EmpathyPreferencesModal and the Giraffe TransformationModal.
 */
export function useOpenerRef(open: boolean): RefObject<HTMLElement | null> {
  const opener = useRef<HTMLElement | null>(null);
  useLayoutEffect(() => {
    if (!open) return;
    const active = document.activeElement;
    opener.current = active instanceof HTMLElement && active !== document.body ? active : null;
  }, [open]);
  return opener;
}
